<template>
    <div class="common-layout">
        <el-container>
        <el-header>
            <el-row>
          <el-col :span="24">
            <el-menu
              class="el-menu-demo"
              mode="horizontal"
              :ellipsis="false"
            >
              <el-menu-item index="0">
                <img src="../../../../src/assets/images/logo.png" alt="img" class="logo" />
              </el-menu-item>
              <div class="flex-grow"/>
            </el-menu>
            <div class="versionSwitch">
                <div>
                    <span style="padding: 0 10px;">用户权限：{{this.userDetail.user_role}} | 用户中文名：{{this.userDetail.user_cnname}}</span>
                    <el-button type="info" :icon="iSwitchButton" circle @click="getloginOut" />
                </div>
            </div>
          </el-col>
        </el-row>
        </el-header>
        <el-container>
            <el-main :style='{height:this.pageHeight}'>
                <el-tabs tab-position="left" style="height: 100%;" class="demo-tabs" v-model="activeTab">
                    <el-tab-pane v-for="item in tapPage" :label="item.label" :name="item.value" :key="item.value" >
                        <component :is="item.components" />
                    </el-tab-pane>
                </el-tabs>
            </el-main>
        </el-container>
        </el-container>
    </div>
</template>

<script>
import { markRaw } from "vue"
import api from '@/api/api'
import cxf from '@/utils/GeneralFn'
import userManage from './component/userManage'
import productManage from './component/productManage'
import newsManage from './component/newsManage'
import { SwitchButton } from '@element-plus/icons-vue'

    export default {
        name: "mg_main",
        components: { 
            SwitchButton: markRaw(SwitchButton)
        },
        data() {
            return {
                iSwitchButton:SwitchButton,
                activeTab:'productManage',
                userDetail:"",
                pageHeight:'1000px',
                tapPage:[
                    {
                        label: "用户管理",
                        value: 'userManage',
                        components: markRaw(userManage)
                    },{
                        label: "产品管理",
                        value: 'productManage',
                        components: markRaw(productManage) 
                    },{
                        label: "新闻管理",
                        value: 'newsManage',
                        components: markRaw(newsManage) 
                    }
                ]
            }
        },
        created(){
        },
        mounted() {
            this.getUserDetail();
            this.getScreenHeight();
        },
        methods:{
            async getUserDetail () {
                const _resUserDetail = await api.getUserDetial();
                const _Data = _resUserDetail.data;
                if ( _Data.success ) {
                    this.userDetail = _Data.data;
                    this.userDetail.user_role = cxf.handleUserRole( this.userDetail.user_role);
                }
                
            },
            getScreenHeight(){
                this.pageHeight = document.documentElement.clientHeight - 60 + 'px'
            },
            getloginOut(){
                this.$confirm('你需要登出系统吗, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(async () => {
                    const _resLoginOut = await api.getloginOut();
                    console.log(_resLoginOut);
                    if ( _resLoginOut.data.success ) {
                        this.$router.push("/manage/mg_Login");
                    } else {
                        this.$message({
                            type:"error",
                            message:"接口退出失败，请联系管理人员。"
                        })
                    }
                });
                
            }
        }
    }
</script>


<style>
.el-tabs__content {
    left:-10px;
}
</style>